var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScheduleChartpeak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120.001,
    viewBox: "0 0 120 120.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389",
    transform: "translate(-825 -400)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersection_7",
    "data-name": "Intersection 7",
    d: "M278.858-3686a42.58,42.58,0,0,0-3.368-16.682A42.718,42.718,0,0,0,266.3-3716.3a42.72,42.72,0,0,0-13.622-9.185A42.588,42.588,0,0,0,236-3728.857V-3746a59.634,59.634,0,0,1,23.354,4.715,60.034,60.034,0,0,1,10.192,5.532,60.4,60.4,0,0,1,8.88,7.327,60.422,60.422,0,0,1,7.327,8.88,59.987,59.987,0,0,1,5.532,10.191A59.6,59.6,0,0,1,296-3686.3v.3Z",
    transform: "translate(649 4146)",
    fill: "#00a8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_10",
    "data-name": "Intersection 10",
    d: "M278.858-3686a42.58,42.58,0,0,0-3.368-16.682A42.718,42.718,0,0,0,266.3-3716.3a42.72,42.72,0,0,0-13.622-9.185A42.588,42.588,0,0,0,236-3728.857V-3746a59.634,59.634,0,0,1,23.354,4.715,60.034,60.034,0,0,1,10.192,5.532,60.4,60.4,0,0,1,8.88,7.327,60.422,60.422,0,0,1,7.327,8.88,59.987,59.987,0,0,1,5.532,10.191A59.6,59.6,0,0,1,296-3686.3v.3Z",
    transform: "translate(1121 -3226) rotate(180)",
    fill: "#5dd622"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_8",
    "data-name": "Intersection 8",
    d: "M278.858-3686a42.58,42.58,0,0,0-3.368-16.682A42.718,42.718,0,0,0,266.3-3716.3a42.72,42.72,0,0,0-13.622-9.185A42.588,42.588,0,0,0,236-3728.857V-3746a59.634,59.634,0,0,1,23.354,4.715,60.034,60.034,0,0,1,10.192,5.532,60.4,60.4,0,0,1,8.88,7.327,60.422,60.422,0,0,1,7.327,8.88,59.987,59.987,0,0,1,5.532,10.191A59.6,59.6,0,0,1,296-3686.3v.3Z",
    transform: "translate(-2801 224) rotate(90)",
    fill: "#c365fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_9",
    "data-name": "Intersection 9",
    d: "M278.858-3686a42.58,42.58,0,0,0-3.368-16.682A42.718,42.718,0,0,0,266.3-3716.3a42.72,42.72,0,0,0-13.622-9.185A42.588,42.588,0,0,0,236-3728.857V-3746a59.634,59.634,0,0,1,23.354,4.715,60.034,60.034,0,0,1,10.192,5.532,60.4,60.4,0,0,1,8.88,7.327,60.422,60.422,0,0,1,7.327,8.88,59.987,59.987,0,0,1,5.532,10.191A59.6,59.6,0,0,1,296-3686.3v.3Z",
    transform: "translate(4571 696) rotate(-90)",
    fill: "#fdbb1d"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Peak",
    transform: "translate(885 465)",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.269,
    y: 0
  }, "Peak")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleChartpeak);
export default __webpack_public_path__ + "static/media/schedule_chartpeak.ba3f1b732264f75e998ead92f5fa575f.svg";
export { ForwardRef as ReactComponent };